import autocomplete from 'jquery-ui/ui/widgets/autocomplete';
import splitDate from 'minerva-form/split-date';

// Classify device as 'phone', 'tablet', or 'desktop'
function detectDeviceType() {
  let type = "desktop"; // default assumption

  const width = window.innerWidth || document.documentElement.clientWidth;
  const isTouch =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  // --- Fallback: check userAgent string ---
  const ua = navigator.userAgent || '';

  if (/Tablet|iPad/i.test(ua)) {
    type = "tablet";
  } else {
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) {
      type = "phone";
    }
  }

  if (type === "desktop" && isTouch && width <= 1024) {
    type = width <= 768 ? "phone" : "tablet";
  }

  return type;
}

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function ensureHiddenInput(form, id, name) {
  let el = document.getElementById(id);
  if (!el && form) {
    el = document.createElement("input");
    el.type = "hidden";
    el.id = id;
    el.name = name;
    form.appendChild(el);
  }
  return el;
}


function getLatestDataLayerValue(key) {
  const layer = Array.isArray(window.dataLayer) ? window.dataLayer : [];

  for (let i = layer.length - 1; i >= 0; i -= 1) {
    const item = layer[i];
    if (item && typeof item === "object" && item[key] !== undefined && item[key] !== null) {
      const value = String(item[key]).trim();
      if (value) {
        return value;
      }
    }
  }

  return "";
}

function captureGtmContext() {
  const applicationForm = document.getElementById("application-form");
  const clientInput = ensureHiddenInput(applicationForm, "id_gtm_client_id", "gtm_client_id");
  const sessionInput = ensureHiddenInput(applicationForm, "id_gtm_session_id", "gtm_session_id");

  if (!clientInput && !sessionInput) {
    return;
  }

  const clientId = getLatestDataLayerValue("client_id");
  const sessionId = getLatestDataLayerValue("session_id");

  if (clientInput && clientId) {
    clientInput.value = clientId;
  }
  if (sessionInput && sessionId) {
    sessionInput.value = sessionId;
  }

  if (!clientId && !sessionId) {
    return;
  }

  const body = new URLSearchParams();
  if (clientId) {
    body.append("gtm_client_id", clientId);
  }
  if (sessionId) {
    body.append("gtm_session_id", sessionId);
  }

  fetch("/application/gtm-context/", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "X-CSRFToken": getCookie("csrftoken") || "",
    },
    body: body.toString(),
    credentials: "same-origin",
  }).catch(() => {
    // Best-effort: hidden form fields still provide capture-on-submit fallback.
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Detect device type and populate hidden field
  const deviceTypeInput = document.getElementById("id_device_type");
  if (deviceTypeInput) {
    const deviceType = detectDeviceType();
    deviceTypeInput.value = deviceType;
  }

  captureGtmContext();

  const applicationForm = document.getElementById("application-form");
  if (applicationForm) {
    applicationForm.addEventListener("submit", captureGtmContext);
  }

  const containers = document.querySelectorAll(".js-minerva-form-autocomplete");
  // Add events to all containers with the class js-minerva-form-autocomplete
  containers.forEach( container => {
    const scriptTag = container.querySelector("script[type='application/json']");
    const input = container.querySelector("input");
    const resultsContainer = container.querySelector("#autocomplete-results");

    if (!scriptTag || !input || !resultsContainer) return;

    const data = JSON.parse(scriptTag.textContent);
    let selectedFromList = false;

    input.addEventListener("input", () => {
      const query = input.value.toLowerCase().trim();
      resultsContainer.innerHTML = "";
      resultsContainer.classList.add("hidden");
      selectedFromList = false;

      if (query.length === 0) return;

      const matches = data.filter((item) =>
        item.toLowerCase().includes(query)
      );

      if (matches.length === 0) return;

      matches.forEach((match) => {
        const li = document.createElement("li");
        li.className = "ui-menu-item px-4 py-2 hover:bg-yellow-100 cursor-pointer transition-colors duration-150";
        li.textContent = match;
        li.addEventListener("click", () => {
          input.value = match;
          selectedFromList = true;
          resultsContainer.classList.add("hidden");
        });
        resultsContainer.appendChild(li);
      });

      resultsContainer.classList.remove("hidden");
    });

    input.addEventListener("blur", () => {
      setTimeout(() => {
        const inputValue = input.value.trim().toLowerCase();
        const isValid = data.some(item => item.toLowerCase() === inputValue);

        if (!isValid) {
          input.value = "";
        }
        resultsContainer.classList.add("hidden");
      }, 180); // Small delay to allow click events to register
    });

    document.addEventListener("click", (e) => {
      if (!container.contains(e.target)) {
        resultsContainer.classList.add("hidden");
      }
    });
  });

  // Select dropdowns (with freetext)
  const selectContainers = document.querySelectorAll("select.js-minerva-form-select");
  selectContainers.forEach(select => {
    const wrapper = select.closest(".js-minerva-form-select-wrapper");
    if (!wrapper) return;

    const freetextContainer = wrapper.querySelector(".js-minerva-form-select-freetext");
    const freetextInput = wrapper.querySelector(".js-minerva-form-select-freetext-content");
    if (!freetextContainer || !freetextInput) return;

    select.addEventListener("change", () => {
      const option = select.options[select.selectedIndex];
      if (option && option.hasAttribute("data-freetext")) {
        freetextContainer.classList.remove("hidden");
      } else {
        freetextContainer.classList.add("hidden");
      }
    });

    freetextInput.addEventListener("change", () => {
      const freetextOption = wrapper.querySelector("option[data-freetext]");
      if (freetextOption) {
        freetextOption.value = freetextInput.value;
      }
    });
  });

  // Password validation
  const passwordValidationContainer = document.querySelector(".js-minerva-form-password-validation-wrapper");
  const passwordInput = document.querySelector('input[type="password"]');
  const minLength = 6;

  if (passwordInput && passwordValidationContainer) {
    passwordInput.addEventListener("input", () => {
      const value = passwordInput.value;
      const hasLetter = /[a-zA-Z]/.test(value);
      const hasNumber = /\d/.test(value);
      const isLongEnough = value.length >= minLength;
      const validationErrors = [];

      if (!isLongEnough && hasLetter && hasNumber) {
        validationErrors.push("Password must be at least 6 characters long.");
      } else if (!hasLetter && isLongEnough && hasNumber) {
        validationErrors.push("Password must include at least one letter.");
      } else if (!hasNumber && isLongEnough && hasLetter) {
        validationErrors.push("Password must include at least one number.");
      } else if (!isLongEnough && !hasLetter && hasNumber) {
        validationErrors.push("Password must be at least 6 characters long and include at least one letter.");
      } else if (!isLongEnough && hasLetter && !hasNumber) {
        validationErrors.push("Password must be at least 6 characters long and include at least one number.");
      } else if (isLongEnough && !hasLetter && !hasNumber) {
        validationErrors.push("Password must include at least one letter and one number.");
      } else if (!isLongEnough && !hasLetter && !hasNumber) {
        validationErrors.push("Password must be at least 6 characters long and include at least one letter and one number.");
      }

      // Clear old messages
      passwordValidationContainer.innerHTML = "";

      if (validationErrors.length > 0) {
        const errorList = document.createElement("ul");
        validationErrors.forEach(error => {
          const li = document.createElement("li");
          li.textContent = error;
          li.className = "text-red-500";
          errorList.appendChild(li);
        });
        passwordValidationContainer.appendChild(errorList);
        passwordValidationContainer.classList.remove("hidden");
      } else {
        passwordValidationContainer.classList.add("hidden");
      }
    });
  }

  // Display source specify
  const displaySource = function(e) {
    const source = $("#id_source").val();
    if(source === "Other" || source === "Minerva Student") {
      $(".source-other").slideDown();
    } else {
      $(".source-other").slideUp();
    }
  };
  displaySource();
  $("#id_source").change(displaySource);

  // Display school name
  const hideSchoolSelect = () => {
    const schoolSelect = document.querySelector(".js-school-select");
    if (schoolSelect) schoolSelect.classList.add("hidden");
  };

  // Display new school
  const displayNewSchoolSelect = () => {
    hideSchoolSelect();
    const newSchool = document.querySelector(".js-new-school");
    if (newSchool) newSchool.classList.remove("hidden");
  };

  // If home schooled is selected, display details
  const schoolLevel = document.querySelector("#id_enrollment_school_level");
  if (schoolLevel) {
    schoolLevel.addEventListener("click", () => {
      const details = document.querySelector('.js-home_schooled_details');
      if (!details) return;
      if (schoolLevel.value === 'home_school') {
        details.classList.remove("hidden");
      }
      else if (!details.classList.contains("hidden")) {
        details.classList.add("hidden");
      }
    });
  }

  // If home schooled is selected, display details
  const gradingScale = document.querySelector("#id_enrollment_grading_scale");
  if (gradingScale) {
    gradingScale.addEventListener("click", () => {
      const details = document.querySelector('.js-no-grading-scale');
      if (!details) return;
      if (gradingScale.value === 'unknown') {
        details.classList.remove("hidden");
      }
      else if (!details.classList.contains("hidden")) {
        details.classList.add("hidden");
      }
    });
  }

  // Add new school
  const addNewSchool = () => {
    displayNewSchoolSelect();
  };

  // School autocomplete
  const idInput = $("#id_school_id");
  const input = $("#id_school_chooser-school_autocomplete");
  let selectedItem;

  if (input.length) {
    input.on("focus", function () {
      if (!$(this).val()) {
        $(this).autocomplete("search", '');
      }
    })
    .autocomplete({
      minLength: 0,

      select: function( event, ui ) {
        if (ui.item && ui.item.id !== undefined) {
          selectedItem = ui.item;
          idInput.val( ui.item.id ).trigger("change");
          input.val( ui.item.name ).trigger("change");
        }
        return false;
      },

      search: function (event, ui) {
        idInput.val("");
      },

      open: function (event, ui) {
      },

      source: function( request, response ) {
        if (request.term.length < 2) {
          response([{
            empty: true
          }]);
          return;
        }
        $.getJSON("/application/schools-autocomplete/", request, function(data, status, xhr) {
          if (data.schools.length === 0) {
            data.schools.push({
              empty: true,
              html: "We don't recognize the name of your school"
            });
          }
          response(data.schools);
        });
      }
    });
    input.autocomplete( "instance" )._renderItem = function( ul, item ) {
      var elem = $("<li>"),
          inner;
      elem.addClass("px-4 py-2 hover:bg-yellow-100 cursor-pointer transition-colors duration-150");
      if (item.empty) {
        elem.addClass("disabled");
        if (item.html === undefined) {
          return elem;
        }
        elem.append(item.html);
      } else {
        elem.attr("data-value", item.name);
        inner = item.name;
        inner += item.location ? ("<br/>" + "<span class='lightest'>" + item.location + "</span>") : "";
        elem.append("<a>").html(inner);
      }
      elem.appendTo(ul);
      return elem;
    };

    // add a "add school" button at the bottom of the menu
    input.autocomplete( "instance" )._renderMenu = function (ul, items) {
      ul.addClass("absolute z-10 mt-1 bg-white border border-gray-300 rounded-md shadow-md hidden max-h-60 overflow-auto text-sm text-gray-800");
      var that = this;
      $.each( items, function( index, item ) {
        that._renderItemData( ul, item );
      });
      var $li = $("<li>").addClass("px-4 py-2 hover:bg-yellow-100 cursor-pointer transition-colors duration-150 flex w-full")
                         .attr("id", "add-new-school")
                         .on("click", addNewSchool),
          $innerDiv = $("<div class='py-1 flex w-full items-center'>")
                        .append("<img class='align-bottom' src='/public/img/icon-circle-plus-orange.svg' />")
                        .append($("<div>").html("If you don't see your school, click to add it.").addClass("ml-2 inline-block"));

      $li.data("ui-autocomplete-item", {});
      $li.append($innerDiv);
      $(ul).append($li);
    };

    // Don't treat any item from the dropdown menu as a divider (especially for the add button)
    input.autocomplete("widget").menu("instance")._isDivider = function( item ) {
      return false;
    };
  }

  // Alternative address display
  const alternativeAddressCheckbox = document.querySelector("#id_living_somewhere_else");
  const fieldContainer = document.querySelector(".js-alternative-address");

  const slideDown = () => {
    // We expect the content to be up to 500px high (adjust as needed)
    fieldContainer.classList.add("opacity-100");
    fieldContainer.classList.remove("opacity-0");
    fieldContainer.style.maxHeight = "500px";
  };

  const slideUp = () => {
    fieldContainer.classList.remove("opacity-100");
    fieldContainer.classList.add("opacity-0");
    fieldContainer.style.maxHeight = "0px";
  };

  if (alternativeAddressCheckbox && fieldContainer) {
    alternativeAddressCheckbox.addEventListener("change", () => {
      if (alternativeAddressCheckbox.checked) {
        slideDown();
      } else {
        slideUp();
      }
    });
    // Initial state based on checkbox
    if (alternativeAddressCheckbox.checked) {
      slideDown();
    } else {
      slideUp();
    }
  }
  document.querySelectorAll(".password-toggle").forEach(button => {
    button.addEventListener("click", function() {
      const targetId = this.getAttribute("data-target");
      const passwordInput = document.getElementById(targetId);
      const eyeOpen = this.querySelector(".eye-open");
      const eyeClosed = this.querySelector(".eye-closed");

      if (!passwordInput || !eyeOpen || !eyeClosed) return;

      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        eyeOpen.classList.add("hidden");
        eyeClosed.classList.remove("hidden");
      } else {
        passwordInput.type = "password";
        eyeOpen.classList.remove("hidden");
        eyeClosed.classList.add("hidden");
      }
    });
  });

  // Show/hide Relative's Name field based on has_minerva_family_member selection
  const familyMemberNameWrapper = document.querySelector(".js-minerva-family-member-name");
  const familyMemberInputs = document.querySelectorAll("input[name='has_minerva_family_member']");
  const familyMemberNameInput = familyMemberNameWrapper
    ? familyMemberNameWrapper.querySelector("input")
    : null;

  const updateFamilyMemberNameVisibility = () => {
    const selectedInput = document.querySelector("input[name='has_minerva_family_member']:checked");
    if (!familyMemberNameWrapper) return;
    if (selectedInput && selectedInput.getAttribute("data-text") === "Yes") {
      familyMemberNameWrapper.classList.remove("hidden");
      if (familyMemberNameInput) familyMemberNameInput.required = true;
    } else {
      familyMemberNameWrapper.classList.add("hidden");
      if (familyMemberNameInput) {
        familyMemberNameInput.required = false;
      }
    }
  };

  familyMemberInputs.forEach(input => {
    input.addEventListener("change", updateFamilyMemberNameVisibility);
  });

  // Initial state for family member name
  updateFamilyMemberNameVisibility();

  const birthdateInput = document.querySelector("[name='birthdate']");
  const parentOptOutWrapper = document.querySelector(".js-parent-opt-out-wrapper");

  const updateParentOptOutVisibility = () => {
    if (!parentOptOutWrapper) return;

    const hideOptOut = () => {
      parentOptOutWrapper.classList.add("hidden");
      const optOutCheckbox = parentOptOutWrapper.querySelector("input[type='checkbox']");
      if (optOutCheckbox) optOutCheckbox.checked = false;
    };

    if (!birthdateInput || !birthdateInput.value.trim()) {
      hideOptOut();
      return;
    }

    // Expected format: mm/dd/yyyy
    const parts = birthdateInput.value.trim().split("/");
    if (parts.length !== 3) {
      hideOptOut();
      return;
    }

    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    if (!day || !month || !year || year < 1900) {
      hideOptOut();
      return;
    }

    const birthdate = new Date(year, month - 1, day);
    const today = new Date();
    const age18Date = new Date(birthdate);
    age18Date.setFullYear(age18Date.getFullYear() + 18);

    if (today >= age18Date) {
      // 18 or older: show opt-out checkbox
      parentOptOutWrapper.classList.remove("hidden");
    } else {
      // Under 18: hide opt-out checkbox and uncheck it
      hideOptOut();
    }
  };

  if (birthdateInput) {
    birthdateInput.addEventListener("change", updateParentOptOutVisibility);
    birthdateInput.addEventListener("input", updateParentOptOutVisibility);
    birthdateInput.addEventListener("changeDate", updateParentOptOutVisibility);
  }

  // Initial state for parent opt-out
  updateParentOptOutVisibility();
});



// WEBPACK FOOTER //
// client/application/start/bundle.js